import { render } from "./ValidatePopup.vue?vue&type=template&id=adda2b64"
import script from "./ValidatePopup.vue?vue&type=script&lang=js"
export * from "./ValidatePopup.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projets\\2023\\PNB\\GECD\\gecd-police-front-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__